import React, { useEffect } from "react";
import { Switch, useRouteMatch } from "react-router-dom";
import PrivateRoute from "../../../../Routes/PrivateRoutes";
import LojaVirtualProvider from "./LojaVirtualContext";
import PesquisarLojaVirtual from "./Events/PesquisarLojaVirtual";
import FormularioLojaVirtual from "./Events/FormularioLojaVirtual";
import { LoadMask } from "../../../../Utils/mask";

const Index = () => {
  useEffect(() => {
    LoadMask();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  let match = useRouteMatch();
  return (
    <LojaVirtualProvider>
      <div className="container-fluid pl-3 pt-3 pb-3">
        <Switch>
          <PrivateRoute
            exact
            path={`${match.url}`}
            component={PesquisarLojaVirtual}
          />
          <PrivateRoute
            path={`${match.url}/:id`}
            component={FormularioLojaVirtual}
          />
        </Switch>
      </div>
    </LojaVirtualProvider>
  );
};

export default Index;
